export enum EntityType {
    LIST = 'LIST', CITATION = 'CITATION', ASSIGNMENT = 'ASSIGNMENT', SECTION = 'SECTION', COLLECTION = 'COLLECTION', SUBMISSION = 'SUBMISSION', CITATION_AVAILBILITY = 'CITATION_AVAILBILITY'
}
